import Slider from 'components/slider';
import AddOfferButton from 'modules/productDetail/addOfferButton';
import CultivationArea from 'modules/productDetail/cultivationArea';
import Description from 'modules/productDetail/description';
import FinancialAmount from 'modules/productDetail/financialAmount';
import FinancialType from 'modules/productDetail/financialType';
import HarvestDate from 'modules/productDetail/harvestDate';
import Header from 'modules/productDetail/header';
import Location from 'modules/productDetail/location';
import RemainingTime from 'modules/productDetail/remainingTime';
import ReportViolation from 'modules/productDetail/reportViolation';
import Roles from 'modules/productDetail/roles';
import Title from 'modules/productDetail/title';
import EmptyImage from 'assets/images/noImage/background store 4.svg';
import useSetSliderImages from 'components/productDetail/hooks/useSetSliderImages';
import {toPersianFinancialType} from 'utilities/helper/toPersianUnits/financialType';
import {useState} from 'react';
import CustomBottomSheet from 'components/bottomSheet';
import OfferForm from '../form';
import Distinguished from 'components/productDetail/distinguished';
const CashPrepaymentDetail = ({
  post,
  app,
  setOpenViolationModal,
}: iPrepaymentDetailProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const {sliderImages} = useSetSliderImages({
    mainImage: post.main_image,
    images: post.images,
  });
  return (
    <div className="px-3 mt-8">
      <Header post={post} />
      {sliderImages.length > 1 ? (
        <Slider images={sliderImages} />
      ) : sliderImages.length === 1 ? (
        <img
          alt="slider"
          src={sliderImages[0]}
          className=" block mx-auto w-36"
        />
      ) : (
        <div className="bg-gray-11 w-full flex h-[200px] rounded-lg my-2">
          <img
            alt="empty"
            src={EmptyImage}
            className=" block mx-auto w-36 bg-gray-11"
          />
        </div>
      )}
      <Title title={post.title} />
      <RemainingTime remainingTime={post.prepayment?.expire_date} />
      <CultivationArea area={post.cultivation?.area} option="هکتار" />
      <HarvestDate date={post.cultivation?.harvest_datetime} />
      <FinancialAmount
        amount={
          post.negotiated_price
            ? 'توافقی'
            : `${Number(post.price).toLocaleString()} تومان`
        }
      />
      <FinancialType type={toPersianFinancialType[post.financial_type]} />
      {post.is_distinguished && <Distinguished date = {post.cultivation?.harvest_datetime} />}
      {post.description && <Description description={post.description} />}{' '}
      <hr className=" mt-6" />
      {post.state && (
        <Location
          location={`${post.state.name} ${
            post.city ? ',' + post.city.name : ''
          }`}
        />
      )}{' '}
      <Roles app={app} />
      <ReportViolation setOpenViolationModal={setOpenViolationModal} />
      <div className="mt-3 pb-12">
        <AddOfferButton icon="icon-presell-card" setIsOpen={setIsOpen} />
      </div>
      <CustomBottomSheet isOpen={isOpen} onDismiss={() => setIsOpen(false)}>
        <>
          <OfferForm setIsOpen={setIsOpen} price={post.price} app={app} />
        </>
      </CustomBottomSheet>
    </div>
  );
};

export default CashPrepaymentDetail;
